import { FC } from 'react';

import { GiftBrandSidebar } from '@service/giftBrand/containers/GiftBrandSidebar';
import { GiftBrandDeliveryManagePage } from '@service/giftBrand/page/GiftBrandDeliveryManagePage';
import { GiftBrandDeliverySearchPage } from '@service/giftBrand/page/GiftBrandDeliverySearchPage';
import { GiftBrandItemListPage } from '@service/giftBrand/page/GiftBrandItemListPage';
import { GiftBrandSettingsPage } from '@service/giftBrand/page/GiftBrandSettingsPage';
import { GiftBrandSettlementInfoPage } from '@service/giftBrand/page/GiftBrandSettlementInfoPage';
import { GiftBrandSettlementPage } from '@service/giftBrand/page/GiftBrandSettlementPage';
import { useAuth } from '@shared/state/hooks/useAuth';
import { Navigate, Route, Routes } from 'react-router-dom';

const GiftBrandLayout: FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <GiftBrandSidebar />
      <div className="lg:pl-60">
        <main className="mx-auto max-w-screen-2xl p-4">
          <Routes>
            <Route path="" element={<Navigate to="/gift-brand/delivery" />} />
            <Route path="delivery" element={<GiftBrandDeliveryManagePage />} />
            <Route
              path="delivery-search"
              element={<GiftBrandDeliverySearchPage />}
            />
            <Route path="items" element={<GiftBrandItemListPage />} />
            <Route path="settlement" element={<GiftBrandSettlementPage />} />
            <Route
              path="settlement-info"
              element={<GiftBrandSettlementInfoPage />}
            />
            <Route path="settings" element={<GiftBrandSettingsPage />} />
            <Route path="*" element={<Navigate to="/gift-brand/delivery" />} />
          </Routes>
        </main>
      </div>
    </div>
  );
};

const GiftBrandAuthRouter: FC = () => {
  const { isGiftBrandSeller, isAdmin } = useAuth();
  const isAuthenticated = isGiftBrandSeller() || isAdmin();

  if (isAuthenticated) {
    sessionStorage.removeItem('redirectUrlAfterGiftBrandLogin');
    return <GiftBrandLayout />;
  }
  return <Navigate to="/gift-brand/login" />;
};

export default GiftBrandAuthRouter;
